/**
 * onayGecidi.js — giriş geçidinin saf kuralları (backlog #540, 2026-10-23). Durumu Components/Contexts/OnayContext.js tutar,
 * ekranı Routes/OnayKapisi.js çizer; "kim sorulur" ve "geçit ne zaman açık" kararları burada, ağ ve React olmadan.
 *
 * KİM SORULUR (Deniz, 2026-10-23): firmanın bu fuardaki arayüz setlerinden biri KATILIMCI ya da DEKORATOR olan gerçek firma
 * girişleri (Yerli ve Yabancı). Organizatör girişleri, personel ve personelin firma ÖNİZLEMESİ sorulmaz (önizleme personel adına bir
 * onay kaydı düşürürdü). Ölçüt aktif set DEĞİL setlerden biri: başlıktaki rol değiştirici geçidi açıp kapatmaz.
 */

/** Geçide tabi portal rolleri (PortalContext arayuzler[].rol). */
export const GECIT_ROLLERI = ['KATILIMCI', 'DEKORATOR'];

/** Bu portal bağlamı geçide tabi mi: gerçek (önizleme değil) firma girişi, bağlam hazır, setlerden biri Katılımcı / Dekoratör. */
export function gecitUygulanir(portal) {
  if (!portal || portal.onizleme || !portal.hazir) return false;
  return (portal.arayuzler || []).some((a) => GECIT_ROLLERI.includes(a?.rol));
}

/**
 * Geçit açık mı: zorunlu bir metin kalmışsa HER ZAMAN (atlama zorunluyu geçemez); yalnızca isteğe bağlılar kalmışsa, atlanmamışsa.
 * `zorunlu` yalnızca AÇIKÇA false ise isteğe bağlıdır (onayMetniService.getBekleyenOnaylar).
 */
export function gecitAcikMi(bekleyenler, atlandi) {
  const liste = bekleyenler || [];
  if (liste.some((m) => m.zorunlu !== false)) return true;
  return liste.length > 0 && !atlandi;
}

/**
 * "Fuar Kuralları" kenar menü öğesi görünür mü (#740, Deniz 2026-11-05). Geçidin ölçütüyle aynı: aktif set DEĞİL, setlerden biri
 * Katılımcı / Dekoratör olan her firma girişi (geçitte sorulan metinleri burada yeniden okuyabilir). Aktif set tek başına bakılırsa,
 * başlıkta başka bir set (Organizatör, Taşeron) seçili ya da ilk gelen olduğunda, geçitte sorulan bir giriş menüde Fuar Kuralları'nı görmezdi.
 * Bağlam yoksa (önizleme dahil bağlam hep vardır) görünmez.
 * WAS (until #740): GECIT_ROLLERI.includes(portal.aktif.rol) -- yalnızca aktif set.
 */
export function fuarKurallariGorunur(portal) {
  if (!portal?.aktif) return false;
  if (GECIT_ROLLERI.includes(portal.aktif.rol)) return true;
  return (portal.arayuzler || []).some((a) => GECIT_ROLLERI.includes(a?.rol));
}

const atlamaAnahtari =(token) => `onayGecidiAtlandi:${token}`;

/** İsteğe bağlı metinlerin bu giriş oturumu için atlandığı, sessionStorage'da (sekme başına; yenilemede kalır, yeni girişte yok). */
export function atlandiMi(token) {
  try {
    return sessionStorage.getItem(atlamaAnahtari(token)) === '1';
  } catch {
    return false;
  }
}

export function atlamayiKaydet(token) {
  try {
    sessionStorage.setItem(atlamaAnahtari(token), '1');
  } catch {
    /* yazılamazsa yalnızca bellekteki işaret kalır (OnayContext) */
  }
}
